// Mirrors PhoneNumberRules (Ruby): NANP +1 + 10 digits — reject 911 as NPA or as NXX (local prefix).
const NANP_E164_TEN_DIGITS = /^\+1(\d{10})$/

export function forbiddenNanp911E164(e164) {
  if (!e164 || typeof e164 !== "string") return false
  const m = e164.trim().match(NANP_E164_TEN_DIGITS)
  if (!m) return false
  const national = m[1]
  const npa = national.slice(0, 3)
  const nxx = national.slice(3, 6)
  return npa === "911" || nxx === "911"
}
